// Standard durations for IDF data (in minutes)
export const durations = [5, 10, 15, 30, 60, 120, 360, 720, 1440];

// Standard return periods for IDF data (in years)
export const returnPeriods = [2, 5, 10, 25, 50, 100];
